import React, { useEffect, useState, useContext } from "react"

import { navigate } from "gatsby"
import { Container, Row } from "react-bootstrap"

import { CANDIDATE_DETAIL_DATA_FETCH } from "../candidate-profile/actions/personalAction"
import {
  CART_FETCH,
  SHORTLIST_FETCH,
} from "../company-profile/statistics/action/statisticsAction"
import { COMPANY_DETAIL_PROFILE_FETCH } from "../company-profile/actions/detailActions"

import { GlobalAuthContext } from "../../context/authContext"

import Spinner from "../spinner/spinner"
import Layout from "../layout/layout"
import SEO from "../seo"
import "./detail.scss"
import PictureSection from "./picture-section"
import InfoSection from "./info-section"
import BreadcrumbComponent from "../breadcrumb/breadcrum"

const DetailPage = ({ username, isCompany, location }) => {
  const [wholePageLoading, setWholePageLoading] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [profile, setProfile] = useState({})
  const [cart, setCart] = useState({})
  const [shortlist, setShortlist] = useState({})

  const { state, dispatch } = useContext(GlobalAuthContext)

  const getTitle = profile => {
    if (profile?.first_name) {
      return (
        profile?.first_name +
        " " +
        profile?.last_name +
        " - " +
        profile?.profile?.position +
        "- WDN"
      )
    }
    return (
      (profile?.profile?.organization_name
        ? profile?.profile?.organization_name
        : profile?.organization_name || "") + " - WDN"
    )
  }

  const getTitleForBreadcrumb = profile => {
    if (profile?.first_name) {
      return profile?.first_name + " " + profile?.last_name
    }
    return profile?.profile?.organization_name
      ? profile?.profile?.organization_name
      : profile?.organization_name
      ? profile?.organization_name
      : ""
  }
  const pages = [{ name: "Home", link: "/" }]
  const currentPage = {
    link: "/",
    name: getTitleForBreadcrumb(
      !!profile?.candidate?.id
        ? profile
        : state?.isAuthenticated
        ? profile?.profile
        : profile
    ),
  }

  const layoutType = () => {
    if (!state.isAuthenticated) {
      return 1
    } else if (state?.isAuthenticated && profile?.profile?.role === "company") {
      if (state?.user?.role === 2) {
        return 3
      }
      return 2
    } else if (state?.isAuthenticated && profile?.role === "candidate") {
      if (state?.user?.role === 2 && state?.user?.id === profile?.id) {
        return 2
      } else if (profile?.contact) {
        return 2
      } else {
        return 3
      }
    } else {
      return 1
    }
  }

  useEffect(() => {
    if (!username) {
      // navigate("/404")
    } else {
      try {
        setWholePageLoading(true)
        if (isCompany) {
          COMPANY_DETAIL_PROFILE_FETCH(
            username,
            setProfile,
            setWholePageLoading
          )
        } else {
          CANDIDATE_DETAIL_DATA_FETCH(username, setProfile, setWholePageLoading)
          if (state?.token && state?.user?.company?.id) {
            CART_FETCH(dispatch, setCart)
            SHORTLIST_FETCH(dispatch, setShortlist, state?.user?.company?.id)
          }
        }
      } catch (err) {
        dispatch({ type: "LOGOUT" })
        navigate("/login")
      }
    }
  }, [state.isAuthenticated, processing, username]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!wholePageLoading) {
    return (
      <Layout
        noVerification={true}
        location={location}
        isAuthenticated={state.isAuthenticated}
      >
        <SEO
          title={getTitle(
            !!profile?.candidate?.id
              ? profile
              : state?.isAuthenticated
              ? profile?.profile
              : profile
          )}
          description={
            profile?.candidate?.cover_letter ||
            profile?.profile?.about ||
            profile?.about
          }
          seoImage={
            profile?.candidate?.avatar ||
            process.env.GATSBY_BASE_URL + profile?.avatar ||
            ""
          }
        />
        <BreadcrumbComponent currentPage={currentPage} pages={pages} />
        <section className="profile-detail">
          <Container>
            <Row>
              <PictureSection
                profile={
                  !!profile?.candidate?.id
                    ? profile
                    : state?.isAuthenticated
                    ? profile?.profile
                    : !!profile?.profile?.avatar
                    ? profile?.profile
                    : profile
                }
                contact={profile?.contact}
                cart={cart}
                shortlist={shortlist}
                setLoading={setProcessing}
                isLoading={processing}
                layoutType={layoutType()}
                username={username}
              />

              <InfoSection profile={profile} layoutType={layoutType()} />
            </Row>
          </Container>
        </section>
      </Layout>
    )
  } else {
    return <Spinner />
  }
}

export default DetailPage
